import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Login, Session} from './user.types';
import { environment } from '../environments/environment';
import * as md5 from 'md5';
import {Subject} from 'rxjs/Rx';
import {Headers, Http, RequestOptions} from '@angular/http';
import {ReplaySubject} from 'rxjs/ReplaySubject';

@Injectable()
export class AuthService {

    private session$: ReplaySubject<Session>;

    constructor(private http: Http) {
        this.session$ = new ReplaySubject(1);

        this.session$.subscribe((session) => localStorage.setItem('sessionId', session.sessionId));

        Observable.timer(0, 5 * 60 * 1000)
            .subscribe(() => this.refresh());
    }

    getSession(): Observable<Session> {
        return this.session$;
    }

    returnSession() {
      return this.session$;
    }

    setSession(session) {
      this.session$.next(session);
    }

    /**
     * @description retuns Obersable of boolean indicating if the user has an authenticated session
     * @returns {Observable<boolean>}
     */
    isLoggedIn(): Observable<boolean> {
        return this.session$
            .map(session => {
                if (!session) {
                  localStorage.removeItem('loggedIn');
                    return false;
                }

                return session.isLoggedIn;
            });
    }

    /**
     * @description Send login request and return Observable which resolves to success status.
     * @param {Login} login
     * @returns {Observable<boolean>}
     */
    login(login: Login): Observable<boolean> {
        const loginClone = Object.assign({}, login);
        loginClone.password = md5(login.password);
        const loginResult$: Subject<boolean> = new Subject();
        this.http.post(environment.apiBaseUrl + 'user/login', loginClone)
            .map(response => response.json())
            .subscribe(session => {
                this.session$.next(session);
                loginResult$.next(session.isLoggedIn === true);
                this.refresh();
            }, (error) => {
                loginResult$.error(error);
            });

        return loginResult$;
    }

    refresh(): Observable<Session> {
        const headers = new Headers();
        const sIdSession = localStorage.getItem('sessionId');
        if (sIdSession) {
            headers.append('Bonanza-Session-Id', sIdSession);
            headers.append('Accept', 'application/json');
        }

        this.http.get(environment.apiBaseUrl + 'user/sessionData', {headers: headers})
            .map(response => response.json())
            .subscribe(session => {
                if (!session.sessionId) {
                    session.sessionId = headers.get('Bonanza-Session-Id');
                }
                localStorage.setItem('sessionData', JSON.stringify(session));
                this.session$.next(session);
            });

        return this.session$;
    }

    logout(): Observable<any> {
        const headers = new Headers();
        headers.append('Bonanza-Session-Id', localStorage.getItem('sessionId'));

        localStorage.removeItem('sessionId');

        return this.http.get(environment.apiBaseUrl + 'user/logout', {headers: headers})
            .map(response => response.json())
            .do(session => {this.session$.next(session), this.refresh(); });

    }

    setLanguage(language): Observable<string> {
        const headers = new Headers();
        headers.append('Bonanza-Session-Id', localStorage.getItem('sessionId'));

        return this.http.get(environment.apiBaseUrl + 'user/language/' + language, {headers: headers}).map(
          response => response.json()
        );
        // return this.refresh()
        //     .map(session => session.language);
    }

}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts